import {IVideoGallery} from "./interfaces";
import React, {useEffect, useState} from "react";
import {getHashByPrefix, getJSONFromHtml} from "../../../domain/common";
import Imgix from "react-imgix";
import {sendGAEvent} from "../../../domain/marketing/gtm-provider";
import Gallery from '../gallery/gallery';
import ArrowIcon from '../../../ui/svg/common/arrow';
import PlayAudioIcon from "../../../ui/svg/audio/play-audio";


interface IVideoGalleryProps {
    videoGallery: IVideoGallery[],
    scrollMarginTop?: number | undefined
}
/**
 * the entry point
 */
const VideoGallery = (props?: IVideoGalleryProps) => {
    const ImageCDNDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase()
    const [videoHash, setVideoHash] = useState<string>('');
    const [firstLoad, setFirstLoad] = useState<boolean>(false);
    const [selectedVideo, setSelectedVideo] = useState<IVideoGallery>();
    const [videoGallery, setVideoGallery] = useState<IVideoGallery[]>();

    useEffect(() => {
        let vGallery = props?.videoGallery;
        if(!vGallery || vGallery.length === 0){
            vGallery = getJSONFromHtml(document.getElementById('video-gallery-data')) as IVideoGallery[];
            //console.log('VideoGallery: ',vGallery);
            if(vGallery){
                const _videoHash = getHashByPrefix('video-');
                if(_videoHash) {
                    findSelectedVideo(_videoHash, vGallery);
                    window.setTimeout(() => {

                        //var elementPosition = document.getElementById('video-gallery-app');
                        document.getElementById('video-gallery-app')?.scrollIntoView();
                        if(props?.scrollMarginTop)
                            window.scrollBy(0, props?.scrollMarginTop);
                        /*if(elementPosition){
                            const y = elementPosition.getBoundingClientRect().top + window.pageYOffset - 150;
                            console.log('scrollTo: ',y);
                            window.scrollTo({top: y, behavior: 'smooth'});
                        }*/

                    }, 500);

                }
                else
                    setSelectedVideo(vGallery[0]);

                setVideoGallery(vGallery);
                // console.log('vGallery: get getJSONFromHtml:',vGallery);
            }
        }
    }, [props?.videoGallery]);


    /**
     * get selected video index in the video items list -
     * used in gallery to jump to the initial slide
     */
    const getSelectedVideoIndex = (selectedVideo: IVideoGallery) => {
        if(!selectedVideo || !videoGallery) return undefined;
        const foundIndex = videoGallery.findIndex(item => item.youTubeCode === selectedVideo.youTubeCode);
        return foundIndex === -1 ? undefined : foundIndex;
    };

    /**
     * find selected video
     */
    const findSelectedVideo = (hash:string, vGallery: IVideoGallery[]) => {
        let isFound = false;
        vGallery.forEach(function(item, i, arr) {
            if( 'video-' + item.nodeAlias ===  hash){
                setSelectedVideo(item);
                isFound = true;
             }
        });
        if(!isFound)
            setSelectedVideo(vGallery[0]);

    };

    /**
     * find selected video
     */
    const selectVideo = (video: IVideoGallery) => {
        if(firstLoad && video === selectedVideo )
            return;

        if(!firstLoad)
            setFirstLoad(true);

        setSelectedVideo(video);
        sendGAEvent('Product Video Thumb', video.documentName)

        const _hash =  window.location.hash.substring(1);
        let _hashReplaced = "";

        const _videoHash = getHashByPrefix('video-');
        if(_videoHash && _videoHash.length > 0) {
            _hashReplaced = _hash.replace(_videoHash, 'video-' + video.nodeAlias);
        }
        else if(_hash && _hash.length > 0)
            _hashReplaced = _hash + '|video-' + video.nodeAlias;
        else{
            _hashReplaced = 'video-' + video.nodeAlias;
        }

        setVideoHash('video-' + video.nodeAlias);
        window.history.replaceState(null, '', document.location.pathname+ document.location.search + "#" + _hashReplaced);
    };

    return (
        <div className="mb-12">
            {
                selectedVideo &&
                <div className="flex flex-col" data-vhash={videoHash} data-bottom-scroll={!(videoGallery?.length && videoGallery?.length < 4)}>

                    <div className="w-full mb-4 ">
                        {!firstLoad &&
                            <div className="w-full relative"
                                 onClick={() => {
                                    setFirstLoad(true);
                                 }}>
                                <div className="absolute left-0 top-0 mt-4 ml-6 text-white text-xl">
                                    { selectedVideo?.documentName }
                                </div>
                                <div className="absolute-center">
                                    <PlayAudioIcon width="60" height="60" color="#000000" bgColor="#ffffff"/>
                                </div>


                                <Imgix
                                    className="w-full mx-auto"
                                    src={ `${ ImageCDNDomain }${ selectedVideo?.previewImage }`}

                                    sizes={"auto"}
                                    htmlAttributes={{
                                        alt: `Image for ${ selectedVideo?.documentName }`,
                                        loading: 'lazy',
                                        width: 1280,
                                        height: 720
                                    }}
                                    imgixParams={{
                                        auto: "format", // Ensures optimal image format
                                    }}
                                />
                            </div>
                        }
                        {firstLoad && <div className="relative" style={{paddingTop: '56.25%'}}>
                            <iframe className="absolute inset-0 w-full h-full"
                                    id='ytplayer'
                                    title='Watch about @Model?.DocumentName.Replace("\"", "")'
                                    src={'https://www.youtube.com/embed/' + selectedVideo?.youTubeCode + '?rel=0;showinfo=0;wmode=opaque;cc_load_policy=1;iv_load_policy=' + selectedVideo?.productVideoLoadPolicy + ';autohide=1;fs=1;origin=waves.com;enablejsapi=1'}
                                    frameBorder="0"
                                    allowFullScreen>
                            </iframe>
                        </div>}
                    </div>

                    {videoGallery && videoGallery?.length > 1 &&
                        <div className="w-full">
                        <Gallery
                            items={ videoGallery || [] }
                            codeName={ 'fmo' }
                            duration={ 800 }
                            desktopItemsPerSlide={ 4 }
                            tableItemsPerSlide={ 4 }
                            mobileItemsPerSlide={ 2.5 }
                            jumpToItemIndex={ getSelectedVideoIndex(selectedVideo) }
                            renderItem={ (item: IVideoGallery) => {

                                const isSelected = selectedVideo && item.youTubeCode === selectedVideo.youTubeCode;

                                return (
                                    <button type="button" className={`h-full text-sm flex flex-col text-left items-start justify-start overflow-hidden cursor-pointer`}
                                         onClick={async evt => {
                                             await selectVideo(item);
                                         }}>
                                        <div className={'relative ' + (isSelected ? 'rounded border-4 border-blue-200 text-blue-200' : 'text-gray-500 opacity-50') }
                                             >
                                            <Imgix
                                                className="max-h-full"
                                                src={ `${ ImageCDNDomain }${ item.previewImage }`}
                                                sizes={"auto"}
                                                htmlAttributes={{
                                                    alt: `Image for ${ item.documentName }`,
                                                    loading: 'lazy',
                                                    width: 275,
                                                    height: 155
                                                }}

                                                imgixParams={{
                                                    auto: "format", // Ensures optimal image format
                                                }}
                                            />
                                            <div className="absolute right-0 bottom-0 py-1 px-2 mr-2 mb-2 bg-gray-700 text-white">{item.videoDurationFormat}</div>
                                        </div>
                                        <div className="mt-2 text-xs lg:text-tiny text-gray-500">{ item.documentName }</div>
                                    </button>
                                )
                            }}
                            prevButtonArrow={
                                <ArrowIcon
                                    width="20px"
                                    rotationAngle={90}
                                    color="#505050"
                                    style={{
                                        marginTop: '-1.5rem'
                                    }}
                                />
                            }
                            nextButtonArrow={
                                <ArrowIcon
                                    width="20px"
                                    rotationAngle={ -90 }
                                    color="#505050"
                                    style={{
                                        marginTop: '-1.5rem'
                                    }}
                                />
                            }
                        />
                        </div>
                    }

                </div>
            }
        </div>
    )
};

export default VideoGallery;